module.exports = __webpack_public_path__ + "img/asphalted_concreted.0e35bb3c.png";